import DataAccess from './constants';
import { genfunction } from '../helpers';
const path = 'LostMemberNoEmail/LostMemberNo';

export const apiLostMember = (params) => {

    var h = new Headers();
    h.append("Authorization", 'Basic ' + genfunction.EncodeBase64(DataAccess.userName + ':' + DataAccess.password));
    h.append('Content-Type', 'application/json');

    let url = DataAccess.apiUrl + path;

    if (params[0]) {
        url += '?LastName=' + params[0].LastName + '&Email=' + params[0].Email;
    }

    const req = new Request(url, {
        method: 'GET',
        headers: h
    })

    return fetch(req);
}